import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="auth-loading">
        <Loader2 className="h-5 w-5 animate-spin mr-2" /> Verifica sessione…
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
